var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-card"},[_c('error-icon'),_c('div',[_c('h1',[_vm._v("403")]),_c('p',[_vm._v("\n      У вас недостаточно прав на просмотр этой страницы."),_c('br'),_vm._v("\n      Вы можете запросить права у администратора или обратиться в\n      "),_c('router-link',{attrs:{"event":'',"to":{
          name: 'Main'
        }}},[_vm._v("\n        контакты\n      ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }